import { Link } from "react-router-dom";
import { SITE_LOGO_ALT } from "@/constants/site";
import { FlameLogo } from "@/components/atoms/FlameLogo";

export type AppLogoProps = {
  /** Icon size in pixels */
  size?: number;
  /** Show BurnChart + AI wordmark beside the icon */
  showWordmark?: boolean;
  /** Wrap in a link to this path (omit for static branding) */
  to?: string;
  className?: string;
  /** Slightly larger wordmark for marketing pages */
  variant?: "default" | "large";
};

export function AppLogo({
  size = 32,
  showWordmark = true,
  to,
  className = "",
  variant = "default",
}: AppLogoProps) {
  const titleSize = variant === "large" ? "text-xl" : "text-lg";
  const content = (
    <>
      <FlameLogo size={size} aria-label={SITE_LOGO_ALT} />
      {showWordmark ? (
        <span className="flex items-center gap-2">
          <span className={`${titleSize} font-black tracking-tight text-white`}>
            BurnChart
          </span>
          <span className="rounded-md bg-brand/15 px-1.5 py-0.5 text-[10px] font-black uppercase tracking-wider text-brand">
            AI
          </span>
        </span>
      ) : null}
    </>
  );

  const classes = `inline-flex shrink-0 items-center gap-2.5 ${className}`;

  if (to) {
    return (
      <Link to={to} className={classes} aria-label="BurnChart AI home">
        {content}
      </Link>
    );
  }

  return <span className={classes}>{content}</span>;
}
